var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray").default;

require("core-js/modules/es6.array.slice.js");

// checks window location to determine if app is running in an allowlist of hosts
var isValidHostname = function isValidHostname(hostname) {
  var hostnames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var validHostnames = ['nerdwallet.com', 'nerdwallet.biz', 'nerdwallet.io', 'nerdwallet.style', 'localhost'].concat(_toConsumableArray(hostnames)); // eslint-disable-next-line no-plusplus -- directive added automatically by Shepherd migration

  for (var i = 0; i < validHostnames.length; i++) {
    var validHostname = validHostnames[i];

    if (validHostname === hostname.slice(-1 * validHostname.length)) {
      return true;
    }
  }

  return false;
};

module.exports = isValidHostname;